import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";
import { Input, Select } from "../../../components/form";
import { Button } from "../../../components/button";
import { usePriceRule, useUpdatePriceRule } from "../hooks";
import { CustomerSelectSearch } from "../../customers/components";
import { useProducts } from "../../products/hooks";

type IUpdatePriceRule = {
  id: string;
};

export const UpdatePriceRule: React.FC = () => {
  const { id } = useParams<IUpdatePriceRule>();
  const navigate = useNavigate();
  const { data: productsData } = useProducts({ where: {}, limit: 100, offset: 0 });

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = usePriceRule(+id!);
  const { form, submit, loading } = useUpdatePriceRule({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("La règle de prix a été modifiée avec succès");
    },
  });

  useEffect(() => {
    if (data?.priceRule?.ok && data?.priceRule?.result) {
      const { result } = data.priceRule;
      form.setValue("customerId", result.customerId);
      form.setValue("quantity", result.quantity);
      form.setValue("priceCents", result.priceCents);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }

  const priceRule = data?.priceRule?.result;

  return (
    <>
      <Header
        title="Règle de prix"
        subtitle={priceRule ? `#${priceRule.id}` : ""}
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/price-rules`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Modifier une règle de prix" />
          <div className="w-full">
            <div className="flex flex-wrap gap-3">
              <Select label="Produit" className="w-full" value={priceRule?.productId ?? ""} disabled>
                <option value="">-</option>
                {productsData?.products?.results?.map((product) => (
                  <option key={product.id} value={product.id}>
                    {product.name}
                  </option>
                ))}
              </Select>
              <CustomerSelectSearch form={form} name="customerId" label="Client (optionnel)" />
              <Input
                label="Quantité minimale (optionnel)"
                type="number"
                className="w-full"
                {...form.register("quantity", { valueAsNumber: true })}
              />
              <Input
                label="Prix (centimes)"
                type="number"
                className="w-full"
                {...form.register("priceCents", { valueAsNumber: true })}
              />
            </div>
            <div className="w-full mt-4">
              <Button onClick={submit} loading={loading} disabled={loading}>
                Valider
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
